import { mockQuoteDetailsFTSinglePayment } from '@domgen/dgx-fe-basket';
import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { RegistrationMessageResult } from '../../models/registration/registration-message-result.enum';
import { RegistrationResponse } from '../../models/registration/registration-response.interface';
import { mockRegistrationApplianceDetails } from '../registration-appliance-details/registration-appliance-details.mock';

export const mockRegistrationResponse: RegistrationResponse = {
  basketItemId: mockRegistrationApplianceDetails.basketItemId,
  firstPayment: 4.96,
  item: mockRegistrationApplianceDetails,
  message: RegistrationMessageResult.Success,
  offerReference: '034-000-093-937',
  person: mockCustomerDetails,
  quote: mockQuoteDetailsFTSinglePayment,
  quoteId: mockRegistrationApplianceDetails.basketQuoteId,
  tax: undefined,
};
